// extracted by css-extract-rspack-plugin
export default {"cls1":"FriendlySutdModal-cls1_OpB","cls2":"FriendlySutdModal-cls2_ykm FriendlySutdModal-cls1_OpB"};